import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "filled-height"
}
const _hoisted_2 = { class: "row mb-20" }
const _hoisted_3 = { class: "col span-6" }
const _hoisted_4 = { class: "col span-6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col span-6" }
const _hoisted_7 = { class: "col span-6" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "col span-12 mb-10" }
const _hoisted_11 = { class: "row mb-10" }
const _hoisted_12 = { class: "col span-12" }
const _hoisted_13 = { class: "row mb-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_NameNsDescription = _resolveComponent("NameNsDescription")!
  const _component_LabeledSelect = _resolveComponent("LabeledSelect")!
  const _component_ResourceLabeledSelect = _resolveComponent("ResourceLabeledSelect")!
  const _component_LabeledInput = _resolveComponent("LabeledInput")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_MetricsRow = _resolveComponent("MetricsRow")!
  const _component_ArrayListGrouped = _resolveComponent("ArrayListGrouped")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_HpaScalingRule = _resolveComponent("HpaScalingRule")!
  const _component_Labels = _resolveComponent("Labels")!
  const _component_Tabbed = _resolveComponent("Tabbed")!
  const _component_CruResource = _resolveComponent("CruResource")!

  return (_ctx.$fetchState.pending)
    ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
    : (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createVNode(_component_CruResource, {
          "done-route": _ctx.doneRoute,
          mode: $props.mode,
          resource: $props.value,
          "validation-passed": true,
          errors: _ctx.errors,
          onError: _cache[9] || (_cache[9] = (e) => (_ctx.errors = e)),
          onFinish: _ctx.save,
          onCancel: _ctx.done
        }, {
          default: _withCtx(() => [
            (!_ctx.isView)
              ? (_openBlock(), _createBlock(_component_NameNsDescription, {
                  key: 0,
                  value: $props.value,
                  mode: $props.mode
                }, null, 8, ["value", "mode"]))
              : _createCommentVNode("", true),
            _cache[23] || (_cache[23] = _createTextVNode()),
            _createVNode(_component_Tabbed, {
              "side-tabs": true,
              "use-hash": _ctx.useTabbedHash,
              "default-tab": _ctx.defaultTab
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Tab, {
                  name: "target",
                  label: _ctx.t('hpa.tabs.target'),
                  weight: 10
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_LabeledSelect, {
                          value: $data.scalableWorkloadType,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($data.scalableWorkloadType) = $event)),
                          options: $data.scalableWorkloadTypes,
                          mode: $props.mode,
                          label: _ctx.t('hpa.workloadTab.targetReferenceType'),
                          required: true
                        }, null, 8, ["value", "options", "mode", "label"])
                      ]),
                      _cache[10] || (_cache[10] = _createTextVNode()),
                      _createElementVNode("div", _hoisted_4, [
                        (_openBlock(), _createBlock(_component_ResourceLabeledSelect, {
                          key: $options.targetResetKey,
                          value: $props.value.spec.scaleTargetRef,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($props.value.spec.scaleTargetRef) = $event)),
                          mode: $props.mode,
                          label: _ctx.t('hpa.workloadTab.targetReference'),
                          required: true,
                          "resource-type": $data.scalableWorkloadType,
                          "paginated-resource-settings": $data.paginateSettings,
                          "all-resources-settings": $data.allSettings
                        }, null, 8, ["value", "mode", "label", "resource-type", "paginated-resource-settings", "all-resources-settings"]))
                      ])
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_LabeledInput, {
                          value: $props.value.spec.minReplicas,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($props.value.spec.minReplicas) = $event)),
                          valueModifiers: { number: true },
                          mode: $props.mode,
                          label: _ctx.t('hpa.workloadTab.min'),
                          placeholder: "1",
                          required: true,
                          type: "number"
                        }, null, 8, ["value", "mode", "label"])
                      ]),
                      _cache[11] || (_cache[11] = _createTextVNode()),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_LabeledInput, {
                          value: $props.value.spec.maxReplicas,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($props.value.spec.maxReplicas) = $event)),
                          valueModifiers: { number: true },
                          mode: $props.mode,
                          label: _ctx.t('hpa.workloadTab.max'),
                          placeholder: "1",
                          required: true,
                          type: "number"
                        }, null, 8, ["value", "mode", "label"])
                      ])
                    ])
                  ]),
                  _: 1,
                  __: [12]
                }, 8, ["label"]),
                _cache[20] || (_cache[20] = _createTextVNode()),
                _createVNode(_component_Tab, {
                  name: "metrics",
                  label: _ctx.t('hpa.tabs.metrics')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrayListGrouped, {
                      value: $props.value.spec.metrics,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($props.value.spec.metrics) = $event)),
                      "default-add-value": { ...$data.defaultResourceMetric },
                      mode: $props.mode,
                      "initial-empty-row": true
                    }, {
                      "remove-button": _withCtx((removeProps) => [
                        ($props.value.spec.metrics.length > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn role-link close btn-sm",
                              onClick: removeProps.remove
                            }, _cache[13] || (_cache[13] = [
                              _createElementVNode("i", { class: "icon icon-x" }, null, -1)
                            ]), 8, _hoisted_8))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9))
                      ]),
                      default: _withCtx((props) => [
                        _createVNode(_component_MetricsRow, {
                          value: props.row.value,
                          "onUpdate:value": ($event: any) => ((props.row.value) = $event),
                          mode: $props.mode,
                          "metrics-available": $options.resourceMetricsAvailable,
                          referent: $options.selectedTargetRef,
                          namespace: $props.value.metadata.namespace
                        }, null, 8, ["value", "onUpdate:value", "mode", "metrics-available", "referent", "namespace"])
                      ]),
                      _: 1,
                      __: [14]
                    }, 8, ["value", "default-add-value", "mode"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _cache[21] || (_cache[21] = _createTextVNode()),
                _createVNode(_component_Tab, {
                  name: "behavior",
                  label: _ctx.t('hpa.tabs.behavior')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.t('hpa.scaleDownRules.label')), 1),
                      _cache[15] || (_cache[15] = _createTextVNode()),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_Checkbox, {
                          value: $options.hasScaleDownRules,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($options.hasScaleDownRules) = $event)),
                          mode: $props.mode,
                          label: _ctx.t('hpa.scaleDownRules.enable')
                        }, null, 8, ["value", "mode", "label"])
                      ]),
                      _cache[16] || (_cache[16] = _createTextVNode()),
                      ($options.hasScaleDownRules)
                        ? (_openBlock(), _createBlock(_component_HpaScalingRule, {
                            key: 0,
                            value: $props.value,
                            type: "scaleDown",
                            mode: $props.mode,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('input', $event)))
                          }, null, 8, ["value", "mode"]))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[19] || (_cache[19] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.t('hpa.scaleUpRules.label')), 1),
                      _cache[17] || (_cache[17] = _createTextVNode()),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_Checkbox, {
                          value: $options.hasScaleUpRules,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($options.hasScaleUpRules) = $event)),
                          mode: $props.mode,
                          label: _ctx.t('hpa.scaleUpRules.enable')
                        }, null, 8, ["value", "mode", "label"])
                      ]),
                      _cache[18] || (_cache[18] = _createTextVNode()),
                      ($options.hasScaleUpRules)
                        ? (_openBlock(), _createBlock(_component_HpaScalingRule, {
                            key: 0,
                            value: $props.value,
                            type: "scaleUp",
                            mode: $props.mode,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('input', $event)))
                          }, null, 8, ["value", "mode"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1,
                  __: [19]
                }, 8, ["label"]),
                _cache[22] || (_cache[22] = _createTextVNode()),
                _createVNode(_component_Tab, {
                  name: "labels-and-annotations",
                  label: _ctx.t('hpa.tabs.labels'),
                  weight: -1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Labels, {
                      "default-container-class": 'labels-and-annotations-container',
                      value: $props.value,
                      mode: $props.mode,
                      "display-side-by-side": false
                    }, null, 8, ["value", "mode"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1,
              __: [20,21,22]
            }, 8, ["use-hash", "default-tab"])
          ]),
          _: 1,
          __: [23]
        }, 8, ["done-route", "mode", "resource", "errors", "onFinish", "onCancel"])
      ]))
}